<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate #htmlform>
    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.content') }}</h2>
      </div>
      <div withRight="admin.element.edit" class="p-col-6 p-text-right" *ngIf="inEdit !== true">
        <button *ngIf="activeNode !== null" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
        <button pButton (click)="onNew()" type="button" label="{{ t('common.labels.new_chapter') }}" icon="pi pi-plus" class="p-button-sm p-button-success p-mb-2 p-ml-2"></button>
        <button *ngIf="activeNode !== null" pButton (click)="onDelete(activeNode)" type="button" label="{{ t('common.labels.delete') }}" icon="pi pi-trash" class="p-button-sm p-button-outlined danger-button p-mb-2 p-ml-2"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <button pButton (click)="onShowVideoLinks()" type="button" label="{{ t('common.labels.videolinks') }}" class="p-button-sm p-button-outlined p-mb-2 p-mr-2"></button>
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div *ngIf="element !== null">

      <div class="p-grid">
        <div class="p-col-4">
          <p-tree [value]="chapters" selectionMode="single" [(selection)]="activeNode" [draggableNodes]="auth.hasRight('admin.element.edit') && inEdit !== true" [droppableNodes]="auth.hasRight('admin.element.edit') && inEdit !== true" [emptyMessage]="t('common.texts.no_chapters')" (onNodeSelect)="onNodeSelect($event)" (onNodeDrop)="onNodeDrop($event)"></p-tree>
        </div>
        <div class="p-col-8 content-box">

          <div *ngIf="inEdit !== true && chapters.length === 0">
            {{ t('common.texts.no_content') }}
          </div>

          <div *ngIf="inEdit !== true && activeNode !== null">
            <h1>{{ activeNode.label }}</h1>
            <div [innerHTML]="activeNode.data | byPassSecurity"></div>
          </div>

          <div *ngIf="inEdit === true">
            <app-form-control [cid]="'chapter'" [control]="form.get('chapter')" [type]="'input'" [label]="t('common.labels.chaptername')"></app-form-control>
            <div class="p-field-acr">
              <label for="content">{{ t('common.labels.content') }}</label>
              <div class="p-inputgroup">
                <editor style="width: 100%" [formControl]="form.get('content')" [init]="getEditorInit()" [class.editor-error]="form.get('content').invalid && form.get('content').dirty"></editor>
                <app-form-error [control]="form.get('content')" [label]="t('common.labels.content')"></app-form-error>
              </div>
            </div>
            <div class="p-field-acr">
              <app-form-control [cid]="'autoplay'" [control]="form.get('autoplay')" [type]="'checkbox'" [label]="t('common.labels.autoplay_for_videos')"></app-form-control>
            </div>
          </div>

        </div>
      </div>

    </div>
  </form>

  <app-inherit-dialog
    [title]="t('common.labels.save')"
    [mode]="'exercise'"
    [(visible)]="saveInheritVisible"
    (okClicked)="saveChapter($event)"
  ></app-inherit-dialog>

  <app-inherit-dialog
    [title]="t('common.labels.delete')"
    [mode]="'exercise'"
    [(visible)]="deleteInheritVisible"
    (okClicked)="deleteChapter($event)"
  ></app-inherit-dialog>

  <!-- VIDEO LINKS -->

  <p-dialog header="{{ t('common.labels.videos') }}" [(visible)]="videosVisible" [draggable]="false" [resizable]="false" modal="true" [style]="{width: '50vw'}">

    <app-loader [loading]="videosLoading"></app-loader>
    <ng-container *ngIf="videosLoading !== true">
      <p-table [value]="videos" styleClass="p-datatable-sm">
        <ng-template pTemplate="body" let-video>
          <tr>
            <td>{{ video.public_name }}</td>
            <td class="p-text-right">
              <button pButton (click)="copyVideoUrl(video.url)" [label]="t('common.labels.copy_url')" class="p-button-outlined p-button-sm"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>

  </p-dialog>

</ng-container>
